import styled from 'styled-components'

export const LeftPanel = styled.div`
    background-color: ${props => props.theme.admin.colors.background};
    position: fixed;
    top: 40px;
    left: -505px;
    bottom: 0;
    width: 500px;
    overflow: auto;
    z-index: 100;
    box-shadow: 0px 0px 5px 0px #cecdcd;
    transition: left 0.15s linear;
    padding: 10px;

    &.active {
        left: 0;
    }
`
